import React from "react";
import NotificationBell from "@components/Notification/NotificationBell";
import Profile from "@features/Profile/Profile";
import { applicationHeaderImage } from "@tvet-mis/psda-assets";
import { OptimizedSvg } from "@components/common/OptimizedSvg";

const Header = React.memo(() => {
	return (
		<header className="sticky top-0 z-30 flex items-center justify-between gap-4 bg-white px-8 py-3 shadow-sm ml-72">
			<div className="flex items-center min-w-0">
				<OptimizedSvg
					width="14rem"
					height="auto"
					src={applicationHeaderImage}
					alt="Skills Punjab"
					className="sidebar-logo block"
					cacheKey="header-image-v1"
				/>
			</div>
			<div className="flex items-center gap-4 flex-shrink-0">
				<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
					<NotificationBell />
				</div>
				<Profile />
			</div>
		</header>
	);
});

export default Header;
